import { useMemo } from "react";
import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";
import RotatingText from "../../../sections/RotationText";
import Image from "next/image";

const SocialProofRotating = () => {
  const { product } = useProductDetail();

  const socialProofItems = useMemo(() => {
    if (!product?.social_proof?.items) return [];
    return product.social_proof.items.map((item) => {
      // Use icon_full from API if available
      const icon = item.icon_full ? (
        <Image
          src={item.icon_full}
          alt={item.icon}
          width={16}
          height={16}
          className="shrink-0"
        />
      ) : null;

      // Use style prop for color like in productCard.utils.tsx
      const colorStyle = item.color_hex ? { color: item.color_hex } : undefined;

      return {
        text: item.text,
        icon,
        style: colorStyle, // Pass color via style prop
      };
    });
  }, [product]);

  if (!product || socialProofItems.length === 0) return null;

  return (
    <RotatingText
      items={socialProofItems}
      mainClassName="text-xs sm:text-sm"
      rotationInterval={3000}
      className="justify-start py-0"
    />
  );
};

export default SocialProofRotating;
